import React from 'react'
import { 
    Form, 
    Icon, 
    Input, 
    Button,
    Checkbox,
} from 'antd'
// import API from '../admin-app/services/API'

class LoginApp extends React.Component {

    constructor(props) {
        super(props)
        this._token = document.getElementById('csrf-token').content
        this.msgEmail = document.getElementById('msgEmail')
        this.msgPassword = document.getElementById('msgPassword')

        console.log(this.msgPassword?this.msgPassword.innerHTML:'')
    }
    
    state = {
        email: '',
        password: '',
      };

    handleChangeEmail = (event) => {
        this.setState({
            email: event.target.value,
        });
    }
    
    handleChangePass = (event) => {
        this.setState({
            password: event.target.value,
        });
    }

    validateForm() {
        return this.state.email.length > 0 && this.state.password.length > 0;
    }
    
    handleSubmit = (/** e */) => {
        /*
        e.preventDefault();
                    
        API.post('api/auth/login', this.state)
        .then((response) => {
            this.setState({
                data: response,
                loading: false,
            })
        })
        .catch(() => {
            this.setState({
                loading: false,
            })
        })
        */
   };
    
    render() {
        return (
            <div style={{ 
                    width: '100%',
                    height: '100vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor:'#001529'
                }}
            >
                <Form 
                    method="POST"
                    action="/login"
                    className='form-login'
                    onSubmit={this.handleSubmit}
                    style={{
                                padding: '20px',
                                width: '300px',
                                verticalAlign: 'middle',
                                borderRadius: '10px',
                                border: '.5px solid gray',
                                backgroundColor:'white'
                            }}
                >
                    <div style={{margin: '10px'}}>
                        <img
                            width="100%"
                            src="/logo.png"
                        />
                    </div>
                    <input 
                        hidden
                        name="_token"
                        value={this._token}                                                
                    />
                    {this.msgEmail?<p>{this.msgEmail.innerHTML}</p>:''}
                    {this.msgPassword?<p>{this.msgPassword.innerHTML}</p>:''}
                    <Form.Item>
                        <Input
                            autoFocus
                            prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            name="email"
                            type="email"
                            placeholder="Correo"
                            onChange={this.handleChangeEmail}
                        />
                    </Form.Item>
                    <Form.Item>
                        <Input
                            prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            name="password"
                            type="password"
                            placeholder="Contraseña"
                            onChange={this.handleChangePass}
                        />
                    </Form.Item>
                    <Form.Item>
                        <Checkbox name="remember">Recordarme</Checkbox>
                        <Button type="primary" htmlType="submit" style={{width: '100%'}}>
                         Iniciar sesión
                        </Button>
                    </Form.Item>
                </Form>
            </div>
		)
	}
}

export default LoginApp
// const WrappedLoginApp = Form.create({ name: 'login-app' })(LoginApp);
// ReactDOM.render(<WrappedLoginAppForm />, mountNode);
